// extracted by mini-css-extract-plugin
export default {"imageRender":"QuadrantBuilder_imageRender__bh2EZ"};